import React from 'react';
import { field, formThemes, customComponentInternalProps } from '../types';
import { ButtonComponent } from 'components/ButtonComponent';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
	formTheme?: formThemes;
	suffix?: string;
	customComponent?: React.FC<customComponentInternalProps>;
};

export default function Custom(props: props) {
	const { valid, cField, handleChange } = props;
	const t = useAppSelector(selectTranslations);
	const propsToCustom: customComponentInternalProps = { valid, cField, handleChange };
	const CustomComponent: React.FC<customComponentInternalProps> | undefined = props.cField.props.customComponent;
	if (CustomComponent === ButtonComponent) {
		propsToCustom.text = t(cField.props.label);
		propsToCustom.handleClick = cField.handleClick;
		propsToCustom.disabled = cField.props.disabled;
		propsToCustom.styleObj = cField.props.sx ?? {};
	}

	return CustomComponent ? <CustomComponent {...propsToCustom}></CustomComponent> : <></>;
}
